export default "__VITE_ASSET__Mm9VWD5a__"